var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('div',{staticClass:"code-view-main"},[_c('img',{staticStyle:{"width":"95px","height":"95px"},attrs:{"src":_vm.url}}),_c('span',{staticStyle:{"font-size":"10px","color":"#333333","margin-top":"5px"}},[_vm._v("扫码关注微信公众号")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }